import { useState } from "react";

type MarketplaceTaxInputProps = {
  value: number;
  onChange: (taxPercent: number) => void;
};

const MINIMUM_TAX_PERCENT = 0;
const MAXIMUM_TAX_PERCENT = 100;

function parseTaxPercent(text: string): number | null {
  if (text.trim() === "") return null;

  const parsed = Number(text);
  if (!Number.isFinite(parsed)) return null;
  if (parsed < MINIMUM_TAX_PERCENT || parsed > MAXIMUM_TAX_PERCENT) return null;

  return parsed;
}

export default function MarketplaceTaxInput({
  value,
  onChange,
}: MarketplaceTaxInputProps) {
  // The draft lets the user clear the field and retype without the input
  // snapping back to the last valid value on every keystroke.
  const [draftText, setDraftText] = useState(String(value));

  function handleChange(text: string) {
    setDraftText(text);

    const parsed = parseTaxPercent(text);
    if (parsed === null) return;

    onChange(parsed);
  }

  function handleBlur() {
    setDraftText(String(value));
  }

  return (
    <div>
      <label
        htmlFor="marketplace_tax"
        className="block text-sm/6 font-medium text-gray-900"
      >
        Marketplace tax (%)
      </label>
      <p className="text-sm text-gray-500">
        Deducted from everything you sell on the marketplace.
      </p>
      <input
        id="marketplace_tax"
        name="marketplace_tax"
        type="number"
        inputMode="decimal"
        min={MINIMUM_TAX_PERCENT}
        max={MAXIMUM_TAX_PERCENT}
        step={0.1}
        value={draftText}
        onChange={(event) => handleChange(event.target.value)}
        onBlur={handleBlur}
        className="mt-2 block w-32 rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
      />
    </div>
  );
}
